module.exports = __webpack_public_path__ + "img/Modelo_masculino.0fb0f701.png";